import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/blog/[slug]/PostActions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/blog/[slug]/PostBody.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/blog/[slug]/PostComments.tsx");
